<template>  
  <div v-if="value.id !== ''">    
    <template v-if="value.category || scheduleEditing">
      <v-flex xs12>
        <strong>Categoria:</strong>
      </v-flex>
      <template v-if="!alteredScheduleSaving">
        <v-flex xs12>
          <v-select
            :items="categories"
            :value="value.category"
            @input="setSelectedScheduleCategory"            
            item-text="name"
            item-value="id"     
            label=""        
            single-line
            :disabled="loadingNew || !scheduleEditing && value.id !== ''"
            bottom
            >
          </v-select>
        </v-flex>
      </template>      
      <v-flex xs12>
        <hr class="mt-2 mb-2">
      </v-flex>
      </template>
      <v-flex xs12>
        <strong v-if="value.itens.length > 1">Itens:</strong>
        <strong v-else>Item:</strong>        
      </v-flex>
      <template v-if="!alteredScheduleSaving">
        <v-flex xs12>
          <!-- Exibir Itens -->        
          <template v-if="loadingNew || !scheduleEditing && value.id !== ''">
            <v-list two-line subheader>          
              <v-list-tile avatar v-for="item in selectedItems" :key="item.id">
                <v-list-tile-content >
                  <v-list-tile-title>{{item.name}}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <template v-if="!item.priceVariations">
                      <span>{{ item.price | currency }}</span>
                    </template>
                    <template v-else>                      
                      <span>{{ item.priceTable[0].price | currency }}</span><span v-if="item.priceTable.length > 1"> e mais {{ item.priceTable.length - 1 }}...</span>
                    </template>
                  </v-list-tile-sub-title>
                </v-list-tile-content>              
              </v-list-tile>            
            </v-list>
          </template>
          <!-- Editar itens -->
          <template v-else>
            <v-card>
              <v-toolbar color="elevation-0">
                <v-text-field
                  v-model="searchItem" 
                  prepend-icon="search" 
                  hide-details 
                  single-line
                  placeholder="Pesquisar itens"                
                  >
                </v-text-field>
                <v-tooltip bottom >
                  <v-btn slot="activator" :disabled="filteredItens.length === 0" icon @click.prevent="selectAllItens">
                    <v-icon color="green darken-2">check_circle</v-icon>
                  </v-btn>  
                  <span>Selecionar todos</span>
                </v-tooltip>              
              </v-toolbar>
              <v-list two-line subheader>          
                <template v-for="(item, index) in filteredItens">
                  <v-list-tile :key="item.id" avatar @click="addSelectedItem(item)">
                    <v-list-tile-content >
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <template v-if="!item.priceVariations">
                          <span>{{ item.price | currency }}</span>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <span slot="activator">{{ item.priceTable[0].price | currency }}</span><span slot="activator" v-if="item.priceTable.length > 1"> e mais {{ item.priceTable.length - 1 }}...</span>
                            <span>
                              <ul>
                                <li v-for="(price, i) in item.priceTable" :key="i">{{ price.description }} - {{ price.price | currency }}</li>
                              </ul>
                            </span>
                          </v-tooltip>
                        </template>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <template v-if="item.priceVariations">
                        <v-tooltip bottom>                                
                          <v-icon
                            slot="activator"
                            v-if="!itemSelected(item.id)"
                            color="grey lighten-1"
                            >
                            crop_square
                          </v-icon>
                          <v-icon
                            slot="activator"
                            v-else
                            color="green darken-2"
                            >
                            done
                          </v-icon>
                          <span>
                            <span>
                              <ul>
                                <li v-for="(price, i) in item.priceTable" :key="i">{{ price.description }} - {{ price.price | currency }}</li>
                              </ul>
                            </span>
                          </span>
                        </v-tooltip>  
                      </template>
                      <template v-else>
                        <v-icon
                          slot="activator"
                          v-if="!itemSelected(item.id)"
                          color="grey lighten-1"
                          >
                          crop_square
                        </v-icon>
                        <v-icon
                          slot="activator"
                          v-else
                          color="green darken-2"
                          >
                          done
                        </v-icon>
                      </template>                              
                    </v-list-tile-action>                  
                  </v-list-tile>         
                  <v-divider v-if="index + 1 < registeredItems.length" :key="index"></v-divider>  
                </template>
              </v-list>
            </v-card>
          </template>        
        </v-flex>
      </template>    
    <v-flex xs12>
      <hr class="mt-2 mb-2">
    </v-flex>
  </div>      
</template>
<script>
export default {
  name: 'item-details',
  props: ['value'],
  data () {
    return {
      loadingNew: false,
      searchItem: ''
    }
  },
  methods: {
    addSelectedItem (item) {
      this.$store.dispatch('addOrRemoveItemSchedule', item)
    },
    selectAllItens () {
      for (let index = 0; index < this.registeredItems.length; index++) {
        this.$store.commit('addItemForScheduled', this.registeredItems[index])
      }
    },
    itemSelected (id) {
      if (this.$store.getters.selectedItens.length === 0) {
        return false
      } else {
        const item = this.$store.getters.selectedItens.filter((elem) => {
          return elem.id === id
        })
        return item.length > 0
      }
    },
    setSelectedScheduleCategory (value) {
      this.$store.commit('setSelectedScheduleCategory', value)
    }
  },
  computed: {
    scheduleEditing () {
      return this.$store.getters.scheduleEditing
    },
    alteredScheduleSaving () {
      return this.$store.getters.alteredScheduleSaving
    },
    alteredSchedule () {
      return this.$store.getters.alteredSchedule
    },
    selectedCategory () {
      return this.$store.getters.selectedScheduleCategory
    },
    registeredItems () {
      return this.$store.getters.registeredItemsActive
    },
    categories () {
      return this.$store.getters.categories
    },
    filteredItens () {
      if (!this.selectedCategory) {
        return []
      } else if (this.searchItem === '') {
        return this.registeredItems.filter(elem => {
          if (elem.categories === this.selectedCategory) {
            return elem
          }
        })
      } else {
        return this.registeredItems.filter((elem) => {
          if (elem.categories === this.selectedCategory) {
            let exp = new RegExp(this.searchItem.trim(), 'i')
            let searchItem = elem.description +
              elem.name +
              elem.tags.join()
            if (elem.priceVariations) {
              searchItem = searchItem + elem.priceTable.map(elemRow => String(elemRow.price).replace('.', ',') + ' ' + String(elemRow.priceRef).replace('.', ',') + ' ' + elemRow.description).join()
            } else {
              searchItem = searchItem + String(elem.price).replace('.', ',')
            }
            return exp.test(searchItem)
          }
        })
      }
    },
    selectedItems () {
      return this.registeredItems.filter(elem => {
        for (let index = 0; index < this.value.itens.length; index++) {
          if (this.value.itens[index].id === elem.id) {
            return elem
          }
        }
      })
    }
  },
  filters: {
    currency (value) {
      let newValue = 0
      if (typeof value !== 'number') {
        newValue = parseFloat(value.replace('.', '').replace(',', '.'))
      } else if (typeof value === 'number') {
        newValue = value
      } else {
        return ''
      }
      return newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>
<style>
/* .item-open-selection:hover {
  background: rgba(0,0,0,0.12);
  cursor: pointer;
} */
</style>



// WEBPACK FOOTER //
// itemDetails.vue?340c5108